<template>
  <tr
    :class="{
      'is-selected': selected,
      'hidden-print': !selected,
      'is-paid': isPaid && !isDeleted,
    }"
  >
    <td class="has-text-centered hidden-print">
      <checkbox v-model="selected" name="selected" />
    </td>
    <td class="has-text-centered hidden-print">
      <UserType :item="item" relationship="orderable_type" />
    </td>
    <td class="has-text-centered">
      <router-link :to="{ name: 'orders.edit', params: { uuid: item.uuid } }">
        {{ item.common_id }}
      </router-link>
    </td>
    <td class="has-text-centered">
      {{ item.created_at | timestamp }}
    </td>
    <td class="has-text-centered">
      <div>
        <router-link
          :to="{
            name: 'customers.edit',
            params: { uuid: item.orderable.customer.uuid },
          }"
        >
          {{ item.orderable.customer.fullName }}
        </router-link>
      </div>
      <div>
        <small>{{ item.orderable.customer.email }}</small>
      </div>
    </td>
    <td class="has-text-centered hidden-print">
      <img
        v-tooltip="{ content: checkoutMethodTitle }"
        v-if="item.checkout_method"
        :src="checkoutMethodIcon"
        class="method-icon"
      />
    </td>
    <td class="has-text-centered visible-print">
      {{ checkoutMethodTitle }}
    </td>
    <td class="has-text-centered hidden-print">
      <img
        v-tooltip="{ content: sendMethodTitle }"
        v-if="item.send_method"
        :src="sendMethodIcon"
        class="method-icon"
      />
    </td>
    <td class="has-text-centered visible-print">
      {{ sendMethodTitle }}
    </td>
    <td class="has-text-centered hidden-print">
      <img
        v-tooltip="{ content: orderMethodTitle }"
        v-if="orderMethodTitle"
        :src="item.order_method.icon"
        class="method-icon"
      />
    </td>
    <td class="has-text-centered visible-print">
      {{ orderMethodTitle }}
    </td>
    <td class="has-text-centered">{{ item.count }}</td>
    <td class="has-text-centered">{{ item.sum_total }}</td>
    <td class="has-text-centered hidden-print">
      <router-link
        :to="{ name: 'orders.edit', params: { uuid: item.uuid } }"
        class="button is-small"
      >
        <span class="icon is-small">
          <span class="fa fa-fw fa-pencil" />
        </span>
      </router-link>
    </td>
  </tr>
</template>

<script>
import PaginatedListItem from '@/views/components/PaginatedList/components/PaginatedListItem';
import UserType from '@/views/components/UserType';
import OrderMixin from '@/mixins/Order';

export default {
  name: 'Order',

  components: {
    UserType,
  },

  extends: PaginatedListItem,

  mixins: [OrderMixin],

  computed: {
    checkoutMethodIcon() {
      if (this.item.checkout_method) {
        return this.item.checkout_method.icon;
      }
      return '';
    },

    sendMethodIcon() {
      if (this.item.send_method) {
        return this.item.send_method.icon;
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
.tag {
  width: 100%;

  &.is-white {
    border: 1px solid #dbdbdb;
  }
}

tr {
  td:first-child {
    border-left: 3px solid #d4d4d4 !important;
  }

  &.is-paid {
    td:first-child {
      border-left: 3px solid #22a684 !important;
    }
  }
}

.status {
  position: relative;
}

.icon--print {
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 50%;
  font-size: 0.85rem;
  position: absolute;
  right: -8px;
  top: -10px;
}
</style>
